import React from 'react';
import ReactDOM from 'react-dom';
import {Link, Redirect} from 'react-router-dom';
import Loader from './Loader';
import AppHeader2 from './AppHeader2';
import Items from './Items';
import BottomMenu from './BottomMenu';
import SidebarPanel from './SidebarPanel';

class Category extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            LOCATION: this.props.location.pathname,
            LOADING: true, 
            categories: [],
            items: [],
            cartEMPTY: 'Y',
            category: props.match.params.id,
            CATEGORYNAME: '',
            CUSTOMER_DET: '',
            page: 1,
            displayLoadMore: ''
        };
    }

    fetchCategoryPage(mode,category,page) {

        var id = localStorage.getItem('delCIRCLE');

        let customer = '';
        if(localStorage.getItem('userData'))
            customer = localStorage.getItem('userData');
        
        var that = this;
        fetch('https://m.donedelivery.in/api/categories_api.php?mode='+mode+'&id='+id+'&category='+category+'&customer='+customer+'&page='+page,{
            mode: 'cors',
            credentials: 'same-origin',
            headers: {
                'Access-Control-Allow-Origin': '*', 
                Accept: 'application/json', 
                'Content-Type': 'application/json',
            },
        }).then(function (response) {
            return response.json();
        }).then(function (result) {
            //console.log(result);
            var CATEGORIES = result.CATEGORIES;
            var ITEMS = result.ITEMS;
            var CATEGORYNAME = result.CATEGORYNAME;
            var CUSTOMER_DET = 'Hi User';
            if(result.CUSTOMER!=='' && result.CUSTOMER!==undefined && result.CUSTOMER!=='undefined')
                CUSTOMER_DET = result.CUSTOMER;

            that.setState({ LOADING:false, categories:CATEGORIES, items:ITEMS, CATEGORYNAME:CATEGORYNAME, CUSTOMER_DET:CUSTOMER_DET, page: result.page, displayLoadMore: result.LOADMORE });
        });
    }

    fetchSecond(mode,category,page) {
        var id = localStorage.getItem('delCIRCLE');

        let customer = '';
        if(localStorage.getItem('userData'))
            customer = localStorage.getItem('userData');
       
        var that = this;
            fetch('https://m.donedelivery.in/api/categories_api.php?mode='+mode+'&id='+id+'&category='+category+'&customer='+customer+'&page='+page,{
              mode: 'cors',
              credentials: 'same-origin',
              headers: {
                  'Access-Control-Allow-Origin': '*', 
                  Accept: 'application/json', 
                  'Content-Type': 'application/json',
              },
          }).then(function (response) {
            return response.json();
          }).then(function (result) {

            var CATEGORIES = result.CATEGORIES;
            var CATEGORYNAME = result.CATEGORYNAME;
            var CUSTOMER_DET = 'Hi User';
            if(result.CUSTOMER!=='' && result.CUSTOMER!==undefined && result.CUSTOMER!=='undefined')
                CUSTOMER_DET = result.CUSTOMER;
            
            that.setState({ items: that.state.items.concat(result.ITEMS), page: result.page, displayLoadMore: result.LOADMORE});
          });
      }
  
      inCartCallBack = () =>{

        let cartEMPTY = 'Y';
        let cart = localStorage.getItem('cartData');
        if(cart !== null && cart!=='{}')
            cartEMPTY = 'N';

        var that = this;
        that.setState({ cartEMPTY:cartEMPTY });
    }
    
    componentWillMount() {
        let mount = $("div").hasClass("modal-backdrop");
        if(mount==true)
        {
            $('body').removeClass('modal-open');
            $(".modal-backdrop").remove();
        }
    }

    componentWillReceiveProps(nextProps) {
        window.location.reload();
        //this.setState({ LOADING:true });
        //this.fetchCategoryPage('CATEGORY',nextProps.match.params.id);
    }

    componentDidMount() {
        this.fetchCategoryPage('CATEGORY',this.state.category, this.state.page);
    }

    loadMore = () => {
        //this.state.loading = true;
        this.fetchSecond('CATEGORY',this.state.category, this.state.page);
      };
  
      render() { 
        let AppHeaderClass = 'appHeader bg-dark text-light';
        let AppHeaderLeft = 'showLINK';
        let AppHeaderLeftLink = '/categories';
        let AppHeaderTitle = 'Categories';
        let AppHeaderRight = '';
        let AppHeaderRightLink = 'SEARCH';
        let AppHeaderSearch = '';

        let props = {
            items: this.state.items,
            inCartCallBack: this.inCartCallBack,
        };
        
        let categories = this.state.categories.map((post, i)=>{
            
            let css = 'btn-outline-mix';
            if(this.state.category==post.ID)
                css = 'tab-active btn-outline-primary';

            return (
                <Link key={post.ID} className={`btn ${css} rounded newshadowed btn-lsm mr-1`} to={`/category/${post.ID}`}>{post.NAME}</Link>
            );
        });

        return (
            <div>
                {this.state.LOADING && <Loader />}
                <AppHeader2 AppHeaderClass={AppHeaderClass} AppHeaderLeft={AppHeaderLeft} AppHeaderLeftLink={AppHeaderLeftLink} AppHeaderTitle={AppHeaderTitle} AppHeaderRight={AppHeaderRight} AppHeaderRightLink={AppHeaderRightLink} AppHeaderSearch={AppHeaderSearch} />
                <div id="appCapsule">
                    {this.state.categories.length>0 &&
                        <div className="section  pt-3 pb-0 pr-0 pl-0 item-tab">
                            <div className="wide-block wide-block2">
                                <div className="text-upper pb-1" style={{'display': 'flex'}}>
                                    <Link className="btn btn-outline-mix rounded btn-lsm mr-1 newshadowed" to="/categories">All</Link>
                                    {categories}
                                </div>
                            </div>
                        </div>
                    }
                    <div className="section pt-0 pb-2">
                        <div className="row">
                            {this.state.items.length>0 && <Items {...props} />}
                        </div>
                        {this.state.displayLoadMore=='Y' && <p>
                            <button type="button" style={{'height': '31px'}} onClick={() => this.loadMore()} className="btn newshadowed text-dgrey font-size-11 square btn-danger btn-llg btn-block goBack">Load More</button>
                        </p>}
                    </div>
                </div>
                <BottomMenu LOCATION={this.state.LOCATION} />
                {this.state.CUSTOMER_DET && <SidebarPanel CUSTOMER_DET={this.state.CUSTOMER_DET}/>}
            </div>
        );
    }
}
      
export default Category;


// WEBPACK FOOTER //
// ./src/components/Category.js